import { client } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { CreateQuoteTemplateInput } from "@onsemble/shared";
import { handleClientMethod } from "../client";

// Re-export for convenience
export type { CreateQuoteTemplateInput };

export const useCreateQuoteTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: CreateQuoteTemplateInput) => {
      return await handleClientMethod(
        client.POST("/api/quote-templates", {
          body: data,
        }),
      );
    },
    onSuccess: (newTemplate) => {
      // Invalidate templates list to refetch
      queryClient.invalidateQueries({ queryKey: ["/api/quote-templates"] });
      // Optionally set the new template in cache
      queryClient.setQueryData(
        ["quote-templates", newTemplate.uid],
        newTemplate,
      );
    },
  });
};
